<template>
  <h1 align="center" style="font-family: sans-serif;font-weight: bold;">Vă rog, așteptați...</h1>
</template>

<script>
import { AUTO_LOGIN } from '@/api.js'

export default {
  created() {
    this.clearUser()

    const code = new URLSearchParams(this.$route.hash.replace(/^#/, '')).get('code')

    const error = msg => {
      this.$toastr.e(msg || 'Autorizarea a eșuat')
      this.logout()
    }

    if (!this.isString(code) || !code.trim()) {
      error()
      return
    }

    AUTO_LOGIN(code).then(res => {
      if (res && res.meta?.HttpStatusMessage == 'OK' && this.isString(res.data?.token?.access_token)) {
        this.login(res.data.token.access_token)
      } else {
        console.log(res);
        
        error(this.isString(res?.response) ? res.response : null)
      }
    }).catch(() => error())
  }
}
</script>
